import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class OrderAttributionWrite
*  Атрибуция источника заказа (идентификаторы веб-аналитики и метки визита).<br>Можно передавать при каждом изменении черновика — снапшот фиксируется<br>при выходе заказа из черновика<br>
*/
export class OrderAttributionWrite extends ActiveModel {

/**
  * clientId
  * ClientID Яндекс Метрики (cookie _ym_uid)<br>
  */
  @ActiveField()
  clientId?: null | string


/**
  * userIdYm
  * UserID, переданный в Метрику через setUserID (задел, включается позже)<br>
  */
  @ActiveField()
  userIdYm?: null | string


/**
  * yclid
  * Метка клика Яндекс Директа<br>
  */
  @ActiveField()
  yclid?: null | string


/**
  * utmSource
  * 
  */
  @ActiveField()
  utmSource?: null | string


/**
  * utmMedium
  * 
  */
  @ActiveField()
  utmMedium?: null | string


/**
  * utmCampaign
  * 
  */
  @ActiveField()
  utmCampaign?: null | string


/**
  * utmContent
  * 
  */
  @ActiveField()
  utmContent?: null | string


/**
  * utmTerm
  * 
  */
  @ActiveField()
  utmTerm?: null | string


/**
  * referrer
  * Реферер первого визита<br>
  */
  @ActiveField()
  referrer?: null | string


/**
  * landingPage
  * Страница входа первого визита<br>
  */
  @ActiveField()
  landingPage?: null | string


  /**
  * consentAnalytics
  * Снимок согласия на аналитику (CMP) на момент оформления;<br>гейтит серверную отправку конверсий (ТЗ §7.2, §11)<br>  */
  @ActiveField(false)
  consentAnalytics: boolean = false
}
